"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const marketInsightApiFactory = (http, prefix = '/market-insights') => ({
    getPricingByPropertyId: (id) => http.get(`${prefix}/property/${id}/pricing`),
});
exports.default = marketInsightApiFactory;
//# sourceMappingURL=market-insight.js.map